import { render, staticRenderFns } from "./ServiceDescriptionDetails.vue?vue&type=template&id=3e196e57&scoped=true&"
import script from "./ServiceDescriptionDetails.vue?vue&type=script&lang=ts&"
export * from "./ServiceDescriptionDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDescriptionDetails.vue?vue&type=style&index=0&id=3e196e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e196e57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VTextField})
